import { peticionesReceiver } from "../../../helpers/peticionesReceiver";
import Notification from "../../../components/Notification/Notification";
import { toast } from "react-toastify";
const API = peticionesReceiver();

export const createSeguro = async (leaveN) => {
    if (leaveN) {
      const params = {
        action: "insert",
        table: "types_insurance",
        rows: leaveN,
        order: "nameTypeInsurance asc",
        validate: [
          ["nameTypeInsurance", "idModule"]
      ]
      };
      API.peticion(params).then((res) => { 
          if (res.status === 200 && res.data.code === "200") {
            toast(<Notification type={"agrega_exito"} withIcon />);
            window.location.href = "#/template/seguros-nomina"
          }else{
            toast(<Notification type={"agrega_error"} backMessage={res.data.message} withIcon />);
          }
        })
        .catch((err) =>{
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
    }
  };

 export const updateSeguro = async (leaveU) => {
    if (leaveU) {
      const params = {
        action: "update",
        table: "types_insurance",
        rows: leaveU,
        condition: {
          keyTypeInsurance: leaveU.keyTypeInsurance,
        },
        validate: [["nameTypeInsurance", "idModule"]]
      };
      API.peticion(params).then((res) => { 
          if (res.status === 200 && res.data.code === "200") {
            toast(<Notification type={"modifica_exito"} withIcon />);
            window.location.href = "#/template/seguros-nomina"
          }else{
            toast(<Notification type={"modifica_error"} backMessage={res.data.message} withIcon />);
          }
        })
        .catch((err) =>{
        toast(<Notification type={"consultar_servidor_error"} withIcon />);
      });
    }
  };